import React from "react";
import {InputGroup} from "react-bootstrap";
import STCInputGroupText from "./STCInputGroup.Text/STCInputGroup.Text";

function STCInputGroup(props){

    return(
        <InputGroup
            id={props.id}
            style={props.style}
            className={props.className}

            as={props.as}
            hasValidation={props.hasValidation}
            size={props.size}
            bsPrefix={props.bsPrefix}
            required={props.required}
        >
            {props.children}
        </InputGroup>
    );
}

STCInputGroup.Text = STCInputGroupText;

export default STCInputGroup;